// extracted by mini-css-extract-plugin
export var actionButton = "_l6-t";
export var buttonContainer = "_l6-0";
export var buttonContainer2 = "_l6-1";
export var buttonSection = "_l6-2";
export var details = "_l6-3";
export var dropdownItem = "_l6-5";
export var dropdownItemsContainer = "_l6-4";
export var fileInput = "_l6-r";
export var headerButton = "_l6-6";
export var icon = "_l6-7";
export var input = "_l6-8";
export var macroListItem = "_l6-9";
export var mainContent = "_l6-a";
export var microText = "_l6-b";
export var modal = "_l6-w";
export var optionsButton = "_l6-c";
export var paperclip = "_l6-s";
export var pillContent = "_l6-d";
export var preview = "_l6-e";
export var preview2 = "_l6-f";
export var quillEditor = "_l6-q";
export var selectedMacro = "_l6-g";
export var sidebar = "_l6-h";
export var sidebarHeader = "_l6-j";
export var sidebarList = "_l6-i";
export var sidebarListItem = "_l6-k";
export var sidebarSearch = "_l6-l";
export var snoozeDurationWrapper = "_l6-v";
export var statusPillContainer = "_l6-m";
export var tagsContainer = "_l6-n";
export var unselectedMacro = "_l6-o";
export var variable = "_l6-u";
export var wrapper = "_l6-p";